<template>
  <div>
    <h1 v-if="getSection">{{getSection.name}} - {{getTitle}}</h1>
    <div class="form-container">
      <!-- Section select -->
      <!-- <div class="input-container">
        <label for="section">{{$t("newInfo.section")}}</label>
        <select
        id="section"
        name="section"
        v-model="$v.articleSection.$model">
          <option disabled :value="null">{{$t("newInfo.sectionPH")}}</option>
          <option
          v-for="section in sections"
          :key="section.id"
          :value="section.id">{{section.name}}</option>
        </select>
        <div class="error-msg">
          <span v-if="$v.articleSection.$error">{{$t("newInfo.errors.section")}}</span>
        </div>
      </div> -->
      <!-- Title input -->
      <div class="input-container">
        <label for="title">{{$t("newInfo.title")}}</label>
        <input
        type="text"
        id="title"
        name="title"
        :placeholder="$t('newInfo.titlePH')"
        v-model="$v.articleTitle.$model">
        <div class="error-msg">
          <span v-if="$v.articleTitle.$error">{{$t("newInfo.errors.title")}}</span>
        </div>
      </div>
      <!-- Subtitle input -->
      <div
      class="input-container"
      v-if="showSubtitle">
        <label for="subtitle">{{$t("newInfo.subtitle")}}</label>
        <input
        type="text"
        id="subtitle"
        name="subtitle"
        :placeholder="$t('newInfo.subtitlePH')"
        v-model="articleSubtitle">
      </div>
      <!-- File input - img -->
      <div
      class="input-container"
      v-if="getSection && getSection.id != 2">
        <label>{{$t("newInfo.image")}}</label>
        <FileUploader
        v-if="!articleLoading"
        :placeholder="$t('newInfo.imagePH')"
        :type="'image/*'"
        :validate="'image/'"
        :label="$t('newInfo.browse')"
        :fileUrl="articleImgUrl"
        @setFile="setFile"/>
      </div>
      <!-- Wysiwyg -->
      <div class="input-container"
      v-if="showWysiwyg">
        <label>{{$t("newInfo.body")}}</label>
        <div class="wysiwyg">
          <Wysiwyg
          v-if="!articleLoading"
          :placeholder="$t('newInfo.bodyPH')"
          :articleBody="articleDelta"
          v-on:updateBody="articleBody = $event"></Wysiwyg>
        </div>
        <div class="error-msg">
          <span v-if="$v.articleBody.$error">{{$t("newInfo.errors.body")}}</span>
        </div>
      </div>
      <!-- Extra data -->
      <div
      id="extra"
      class="input-container"
      v-if="getSection && getSection.id == 2">
        <label>{{$t("newInfo.extra")}}</label>
        <!-- Order -->
        <!-- <div class="input-container">
          <label for="order">{{$t("newInfo.order")}}:</label>
          <input
          type="text"
          name="order"
          id="order"
          v-model.number="$v.articleOrder.$model">
        </div>
        <div v-if="$v.articleOrder.$error" class="error-msg">
          <p v-if="!$v.articleOrder.required">{{$t("newInfo.errors.order_req")}}</p>
          <p v-if="!$v.articleOrder.integer">{{$t("newInfo.errors.order_num")}}</p>
        </div> -->
        <!-- Latitud -->
        <div class="input-container">
          <label for="latitud">Latitud:</label>
          <input
          type="text"
          name="latitud"
          id="latitud"
          v-model.number="$v.latitud.$model">
        </div>
        <div v-if="$v.latitud.$error" class="error-msg">
          <p v-if="!$v.latitud.isRequired">{{$t("newInfo.errors.lat_req")}}</p>
          <p v-if="!$v.latitud.decimal">{{$t("newInfo.errors.lat_num")}}</p>
        </div>
        <!-- Longitud -->
        <div class="input-container">
          <label for="longitud">Longitud:</label>
          <input
          type="text"
          name="longitud"
          id="longitud"
          v-model.number="$v.longitud.$model">
        </div>
        <div v-if="$v.longitud.$error" class="error-msg">
          <p v-if="!$v.longitud.isRequired">{{$t("newInfo.errors.long_req")}}</p>
          <p v-if="!$v.longitud.decimal">{{$t("newInfo.errors.long_num")}}</p>
        </div>
        <!-- <pair-value
        v-if="!articleLoading"
        :keyLabel="$t('newInfo.extraKey')"
        :valueLabel="$t('newInfo.extraValue')"
        :emptyLabel="$t('newInfo.extraEmpty')"
        :articleExtra.sync="articleExtra"
        /> -->
      </div>
      <!-- Cancel / Publish controllers -->
      <div class="input-container controllers">
        <div class="error-msg">
          <span v-if="serverError">{{$t("newInfo.errors.server")}}</span>
        </div>
        <span
        class="control cancel-btn"
        @click="cancelPublish">{{$t('newInfo.cancel')}}</span>
        <button
        type="button"
        class="btn btn-dark control publish-btn"
        :disabled="isLoading"
        @click="validateForm">{{$t('newInfo.publish')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import GenInfo from "@/lib/api/GeneralInfo";
import S3_Handler from "@/lib/api/s3_handler";
import { required, decimal, integer } from "vuelidate/lib/validators";
const FileUploader = () => import("@/components/FileUploader");
const Wysiwyg = () => import("@/components/Wysiwyg");
const PairValue = () => import("@/components/PairValue");

export default {
  components: {
    FileUploader,
    Wysiwyg,
    PairValue
  },
  props: {
    section: {
      required: false
    },
    order: {
      required: false
    },
    articleId: {
      required: false,
      default: null
    }
  },
  data: function() {
    return {
      isLoading: false,
      articleLoading: true,
      serverError: false,
      sections: null,
      articleSection: this.section || null,
      articleTitle: null,
      articleSubtitle: null,
      articleImage: null,
      articleImgUrl: null,
      articleDelta: null,
      articleBody: null,
      articleExtra: null,
      // articleOrder: this.order || null,
      articleOrder: this.order,
      latitud: null,
      longitud: null
    };
  },
  computed: {
    getTitle: function() {
      if (this.$route.name == "Info Edit") {
        return this.$t("updateInfo.update");
      } else {
        return this.$t("newInfo.new");
      }
    },
    getSection: function() {
      if(this.sections) {
        return this.sections.filter(section => 
          section.id == this.articleSection
        )[0];
      } else {
        return;
      }
    },
    getSectionData: function() {
      return this.sections.filter(section => 
        section.id == this.articleSection
      )[0].options;
    },
    showWysiwyg: function() {
      if ((this.getSection && this.getSection.id == 4) || (this.section && this.section == 4)) return false;
      if ((this.getSection && this.getSection.id == 8) || (this.section && this.section == 8)) return false;
      return true;
    },
    showSubtitle: function() {
      if ((this.getSection && this.getSection.id == 7) || (this.section && this.section == 7)) return false;
      return true;
    }
  },
  validations: {
    articleTitle: {
      required
    },
    articleBody: {
      required
    },
    latitud: {
      decimal,
      isRequired: function() {
        if(this.longitud){
          if(this.latitud) {
            return true;
          }
          return false;
        }
        return true;
      }
    },
    longitud: {
      decimal,
      isRequired: function() {
        if(this.latitud){
          if(this.longitud) {
            return true;
          }
          return false;
        }
        return true;
      }
    }
  },
  beforeMount: async function() {
    await this.getSections();
    // if (this.articleId) {
    //   this.getArticle();
    // } else {
    //   this.articleLoading = false;
    // }
  },
  methods: {
    getSections: async function() {
      this.$store.commit("global/SET_LOADING", true);
      const service = new GenInfo();
      try {
        const response = await service.getSections();
        this.sections = response;
        if(this.articleId) {
          await this.getArticle();
        } else {
          this.articleBody = {"ops":[{"insert":" \n"}]};
          this.articleLoading = false;
        }
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    getArticle: async function() {
      this.$store.commit("global/SET_LOADING", true);
      const service = new GenInfo();
      try {
        const response = await service.getArticle(this.articleId);
        this.articleSection = response.section;
        this.articleTitle = response.title;
        this.articleSubtitle = response.subtitle;
        this.articleImgUrl = response.cover;
        this.articleDelta = response.body;
        this.articleBody = response.body;
        this.articleOrder = response.extra.order;
        this.latitud = response.extra.lat;
        this.longitud = response.extra.long;
        this.articleLoading = false;
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.articleLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    setFile: function(file) {
      this.articleImage = file;
    },
    cancelPublish: function() {
      this.$router.push({
        name: "Info List"
      });
    },
    validateForm: function() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      this.postArticle();
    },
    postArticle: async function() {
      this.serverError = false;
      this.isLoading = true;
      this.$store.commit("global/SET_LOADING", true);
      const service = new GenInfo();
      const s3 = new S3_Handler();
      try {
        const timestamp = Date.now();
        const imageResp = await this.uploadImage(timestamp);
        // Upload Wysiwyg to body
        // const bodyResp = await s3.uploadFile(`${timestamp}_body.json`, JSON.stringify(this.articleBody));
        const article = {
          ...this.getSectionData,
          title: this.articleTitle,
          subtitle: this.articleSubtitle,
          cover: imageResp,
          // body: bodyResp.Location,
          body: this.articleBody,
          author: this.$store.getters["session/userControl"],
          published: true,
          extra: {
            order: parseInt(this.articleOrder),
            lat: this.latitud,
            long: this.longitud,
            ...this.articleExtra
          }
        };
        if (this.$route.name == "Info Edit") {
          await service.updateArticle(article, this.articleId);
        } else {
          await service.postArticle(article);
        }
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        this.$router.push({
          name: "Info List"
        });
      } catch (error) {
        this.serverError = true;
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    uploadImage: async function(timestamp) {
      let s3 = new S3_Handler();
      try {
        if (this.articleImage) {
          const response = await s3.uploadFile(`${timestamp}.${this.articleImage.name.split(".").pop()}`, this.articleImage);
          return response.Location;
        } else {
          if (this.articleImgUrl) {
            return this.articleImgUrl;
          }
          return null;
        }
      } catch (error) {
        throw error;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-container {
  width: 90%;

  @media (min-width: 769px) {
    width: 65%;
  }
  @media (min-width: 1216px) {
    width: 55%;
  }
  @media (min-width: 1408px) {
    width: 45%;
  }
}

.input-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 18px;
  margin: 20px 0px;

  label {
    @extend %audi-b;
  }
}
.wysiwyg {
  width: 100%;
}
#extra {
  .input-container {
    display: flex;
    flex-direction: row;
    margin: 0;
  }
  input {
    width: auto;
    margin-left: 10px;
  }
}
.controllers {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.controllers .control {
  margin-left: 15px;
  font-size: 16px;
  cursor: pointer;
}
.publish-btn {
  @extend %audi-b;
  color: $white;
  background-color: $black;
  padding: 10px 20px;
  border-radius: 0px;
}
.error-msg {
  color: $warn_red;
  font-size: 14px;
}
</style>
